const BaseModule = require('../../90_utils/base/BaseModule');

class Stat extends BaseModule {

	constructor(el, params) {

		super(el);

		this.$statNumber = this.$el.find('.stat-number');
	}

	// basemodule methods

	_domReady(){
		this._domUpdate();
	}

	_addListeners(){ }

	_removeListeners(){ }

	// listener methods

	_onReadMoreClick(e){
		e.preventDefault();
	}

	//

	_show(){ }
	_hide(){ }

	_enable(){ }
	_disable(){ }

	_domUpdate(){
		let numString = this.$statNumber.text().replace(/\,/g,'');
		let numDec = numString.indexOf('.') >= 0 ? numString.length - numString.indexOf('.') - 1 : 0;
		let commaNumber = window.utils.NumberUtils.formatNumber(parseFloat(numString), 1, numDec, true);
		console.log(this.$statNumber.text(), numString, parseFloat(numString));
		this.$statNumber.html(commaNumber);
	}

	_resize(){ }
}

module.exports = Stat;
